import React from 'react'
import Skeleton from 'react-loading-skeleton'
import Button from '../components/Button'
import ImageVideoSlider from '../components/ImageVideoSlider'
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const ImageTitleTextButton = ({ module, images, title, shortTitle, description, buttons, equalCol, imagePosition, sectionColor, faqData, showFaq = false, bgGray = false, halfGrey = false, smallFont = false, sectionId, highlight = false, index }) => {

    const mergeConsecutiveLists = (content) => {
        if (!Array.isArray(content)) return content;

        const merged = [];

        content.forEach((block) => {
            const lastBlock = merged[merged.length - 1];

            // Merge consecutive unordered lists
            if (
                block?.type === "list" &&
                lastBlock?.type === "list" &&
                block?.format === lastBlock?.format
            ) {
                lastBlock.children = [
                    ...(lastBlock.children || []),
                    ...(block.children || []),
                ];
            } else {
                merged.push({ ...block });
            }
        });

        return merged;
    };

    return (
        <section className={`pt-pb-10 ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} sec-${module?.Modul_Farbe ? module?.Modul_Farbe?.split(" ")[0] : sectionColor}-color ${module?.grauer_Hintergrundfarbe && !halfGrey ? 'sec-bg-grey' : ''} ${halfGrey ? 'half-grey-sec' : ''}`} id={sectionId}>
            <div className='container'>
                <div className={`row ${imagePosition !== 'Rechts' ? 'flex-lg-row-reverse' : ''}`}>
                    <div className={`${equalCol === "Ja" ? 'col-lg-6' : 'col-lg-7'} content-col mb-4 mb-lg-0 align-self-center tick_list vision_${index}`}>
                        {shortTitle && <div className='subtitle'>{shortTitle}</div>}
                        {title && <h2 className={`text-black mb-2`}>{title}</h2>}
                        <div className="d-lg-none d-block mb-4 mt-3">
                            <ImageVideoSlider images={images} navSlider={module?.Arrow_slider} videoThumbnail={module?.Videominiatur} video={module?.Video} Bild_oder_Video={module?.Bild_oder_Video} sectionColor={sectionColor} />
                        </div>
                        {description && (
                            <BlocksRenderer content={mergeConsecutiveLists(description)} />
                        )}

                        {highlight && <div className="highlight">
                            <h4>Im Moment haben wir keine freien Stellen</h4>
                            </div>}
                        {showFaq &&
                            <div className="accordion accordion-sec-wrapper" id="faqAccordion">
                                {showFaq && (
                                    <div className="accordion accordion-sec-wrapper" id="faqAccordion">
                                        {faqData.map((item, index) => (
                                            <div className="accordion-item" key={item.id}>
                                                <div className="accordion-header">
                                                    <button
                                                        className="accordion-button collapsed fs_24"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse-${item.id}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapse-${item.id}`}
                                                    >
                                                        {item?.Titel}
                                                    </button>
                                                </div>

                                                <div
                                                    id={`collapse-${item.id}`}
                                                    className="accordion-collapse collapse"
                                                    data-bs-parent="#faqAccordion"
                                                >
                                                    <div className="accordion-body">
                                                        {/* <p>{item.Text}</p> */}
                                                        {item?.Text && <BlocksRenderer content={item?.Text} />}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>}
                        {/* <Button  buttons={buttons} btnStyle="round_btn" /> */}
                        <Button component={module?.Komponente} pdf={module?.PDF} buttons={buttons} btnStyle="round_btn" />
                    </div>
                    <div className={`${equalCol === "Ja" ? 'col-lg-6' : 'col-lg-5'} image-col d-lg-block d-none`}>
                        <ImageVideoSlider images={images} navSlider={module?.Arrow_slider} videoThumbnail={module?.Videominiatur} video={module?.Video} Bild_oder_Video={module?.Bild_oder_Video} sectionColor={sectionColor} moduleColor={module?.Modul_Farbe} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ImageTitleTextButton